import { prop, arrayToObject } from '../../utilities';

function getZemplinProductDefaultInfo(product, goodName = 'main_good') {
  const unit = prop(product, `${goodName}.units`) || 'ks';
  const heliosUnit = prop(product, `${goodName}.helios_units`);
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';

  const customOrderNrs = prop(product, `${goodName}.custom_order_nr`, ['']);
  const orderNr = customOrderNrs
    ? customOrderNrs[customOrderNrs.length - 1]
    : '';

  const productPackages = prop(product, 'productPackages', []);
  const minQuantity = prop(product, `${goodName}.order_quantity_min`);
  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const b2bDiscount = prop(product, `${goodName}.b2b_discount`, null);

  const assembling = prop(product, 'assembling');

  const storesInfo = prop(product, `${goodName}.stores_info`, null);
  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;
  const correctZemplinCount = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity') -
      prop(storesInfoObj, 'ordered.quantity') +
      prop(storesInfoObj, 'external.quantity')
    : null;
  const onStockCount = correctZemplinCount
    ? correctZemplinCount
    : prop(product, `${goodName}.on_stock_count`, 0);

  const customerDiscount = prop(product, `${goodName}.customer_discount`);

  const correctCount = isMks ? (onStockCount / 1000).toFixed(3) : onStockCount;
  const price = prop(product, `${goodName}.final_price`);
  const oldPrice = prop(product, `${goodName}.oldprice`);
  const priceWithoutVat = prop(product, `${goodName}.final_price_without_vat`);
  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(2)
      : price.toFixed(2)
    : '';
  const correctOldPrice = oldPrice
    ? isMks
      ? (1000 * oldPrice).toFixed(2)
      : oldPrice.toFixed(2)
    : '';
  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(2)
      : priceWithoutVat.toFixed(2)
    : '';

  const mocPrice = prop(product, `${goodName}.unitprice`);

  const unpackingCost = prop(product, `${goodName}.sum_unpacking_cost`);

  return {
    unit: correctUnit,
    onStock: correctCount,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    oldPrice: correctOldPrice,
    assembling,
    orderNr,
    productPackages: correctPackageNumber,
    priceForPiece: priceWithoutVat,
    customerDiscount: customerDiscount ? customerDiscount.toFixed(2) : null,
    mocPrice: mocPrice ? mocPrice.toFixed(2) : null,
    b2bDiscount,
    unpackingCost,
    storesInfo,
  };
}

const getElasticCategoryZemplinProductInfo = product => {
  const unit = prop(product, 'helios_units')
    ? prop(product, 'helios_units')
    : 'ks';
  const isMks = unit === 'Mks';

  const storesInfo = prop(product, `stores_info`, null);
  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;
  const correctZemplinCount = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity') -
      prop(storesInfoObj, 'ordered.quantity') +
      prop(storesInfoObj, 'external.quantity')
    : null;
  const onStockCount = correctZemplinCount
    ? correctZemplinCount
    : prop(product, `main_good_stock_count`, 0);
  const correctCount = isMks ? (onStockCount / 1000).toFixed(3) : onStockCount;

  const price = prop(product, `product_detail.main_good.final_price`);
  const priceWithoutVat = prop(
    product,
    `product_detail.main_good.final_price_without_vat`,
  );

  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(2)
      : price.toFixed(2)
    : '';

  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(2)
      : priceWithoutVat.toFixed(2)
    : '';

  const productPackages = prop(product, `product_packages`);
  const goods = prop(product, `product_detail.goods`, []);
  const minQuantity = goods ? prop(goods[0], `order_quantity_min`, null) : null;
  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const unpackingCost = prop(
    product,
    `product_detail.main_good.sum_unpacking_cost`,
  );

  const customOrderNrs = prop(product, 'custom_order_nrs');
  const customOrderNr =
    customOrderNrs && customOrderNrs[0] ? customOrderNrs : null;

  return {
    onStock: correctCount,
    storesInfo,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    unit,
    productPackages: correctPackageNumber,
    unpackingCost,
    customOrderNr,
  };
};

function getZemplinCartProductInfo(product) {
  const unit = prop(product, 'good.units') || 'ks';
  const heliosUnit = prop(product, 'good.helios_units');
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';

  const productPackages = prop(product, 'product.productPackages', []);
  const minQuantity = prop(product, `good.order_quantity_min`);
  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const count = prop(product, 'count');
  const correctCount = isMks ? count / 1000 : count;

  const price = prop(product, `good.final_price`);
  const priceWithoutVat = prop(product, `good.final_price_without_vat`);
  const sumPrice = prop(product, `sum_price`);
  const sumPriceWithoutVat = prop(product, `sum_price_without_vat`);

  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(2)
      : price.toFixed(2)
    : '';
  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(2)
      : priceWithoutVat.toFixed(2)
    : '';

  return {
    count: correctCount,
    unit: correctUnit,
    productPackages: correctPackageNumber,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    priceForPiece: price,
    priceForPieceWithoutVat: priceWithoutVat,
    sumPrice: sumPrice ? sumPrice.toFixed(2) : '',
    sumPriceWithoutVat: sumPriceWithoutVat ? sumPriceWithoutVat.toFixed(2) : '',
  };
}

function getZemplinCartSummaryInfo(cart) {
  const vatGroups = prop(cart, 'vat_groups', null);
  if (!vatGroups) {
    return {
      vatGroups: null,
    };
  }
  const vatGroup0Total = prop(vatGroups['0'], 'price_without_vat')
    ? prop(vatGroups['0'], 'price_without_vat').toFixed(2)
    : null;
  const vatGroup0TotalWithDph = prop(vatGroups['0'], 'price')
    ? prop(vatGroups['0'], 'price').toFixed(2)
    : null;
  const vatGroup20Total = prop(vatGroups['20'], 'price_without_vat')
    ? prop(vatGroups['20'], 'price_without_vat').toFixed(2)
    : null;
  const vatGroup20TotalWithDph = prop(vatGroups['20'], 'price')
    ? prop(vatGroups['20'], 'price').toFixed(2)
    : null;
  const vatGroup20TotalDph = vatGroup20TotalWithDph - vatGroup20Total;

  return {
    vatGroup0Total,
    vatGroup0TotalWithDph,
    vatGroup20Total,
    vatGroup20TotalWithDph,
    vatGroup20TotalDph: vatGroup20TotalDph
      ? vatGroup20TotalDph.toFixed(2)
      : null,
  };
}

function getZemplinTrueCount(isMks: boolean, count: number) {
  return isMks ? Math.round(count * 1000) : count;
}

function getZemplinTrueCountFromNormalCount(isMks: boolean, count: number) {
  return isMks ? count / 1000 : count;
}

function getCorrectPackageNumber(packages, isMks: boolean) {
  if (!packages || packages.length === 0) {
    return 0;
  }

  const packageNumbers = packages.map(p => p.type);
  const min = Math.min(...packageNumbers);

  return isMks ? min / 1000 : min;
}

function isOrderingLessThanMinimum(product) {
  const { count, productPackages } = getZemplinCartProductInfo(product);

  if (count >= productPackages) {
    return true;
  }

  return false;
}

function getZemplinRequestDetailItemInfo(item) {
  const unit = prop(item, 'good_details_json.units');
  const heliosUnit = prop(item, 'good_details_json.heliosUnits');
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';
  const quantity = prop(item, 'quantity');

  const correctCount = isMks ? quantity / 1000 : quantity;

  return {
    count: correctCount,
    unit: correctUnit,
  };
}

function shouldShowPriceIfNotOnStock(categoryIds: string[]) {
  return !categoryIds.includes('SPOJ_MATERIAL');
}

function isCategory(categoryIds: string[], wantedCategory: string) {
  return categoryIds.includes(wantedCategory);
}

export {
  getZemplinProductDefaultInfo,
  getElasticCategoryZemplinProductInfo,
  getZemplinCartProductInfo,
  getZemplinTrueCount,
  getCorrectPackageNumber,
  getZemplinRequestDetailItemInfo,
  isOrderingLessThanMinimum,
  getZemplinTrueCountFromNormalCount,
  getZemplinCartSummaryInfo,
  shouldShowPriceIfNotOnStock,
  isCategory,
};
